import axios from 'axios';

const getFornecedoresGestaoGrupos = params => axios.get('/fornecedores-gestao-grupos', {
  params,
});

const get = id => axios.get(`/fornecedores-gestao-grupos/${id}`);

const save = (tabelaPreco) => {
  if (tabelaPreco.id) {
    return axios.put(`/fornecedores-gestao-grupos/${tabelaPreco.id}`, tabelaPreco);
  }
  return axios.post('/fornecedores-gestao-grupos', tabelaPreco);
};

const remove = id => axios.delete(`/fornecedores-gestao-grupos/${id}`);

export default {
  get,
  getFornecedoresGestaoGrupos,
  save,
  remove,
};
